import { useDraggable } from "@dnd-kit/core";

import { classNames } from "utils/common";

import type { QuestionElement } from "models";

type AvailableQuestionElementProps = {
  questionElement: QuestionElement;
};

export const AvailableQuestionElement = ({ questionElement }: AvailableQuestionElementProps) => {
  const { setNodeRef, attributes, listeners, isDragging } = useDraggable({ id: questionElement.id });

  return (
    <div ref={setNodeRef} className={`available-question-element ${classNames({ "is-dragging": isDragging })}`} {...attributes} {...listeners}>
      <span>{questionElement.name}</span>
      <strong>{questionElement.template}</strong>
    </div>
  );
};
